import { setLogger } from './logger';
export function configureReactLogger(logger) {
    setLogger(logger);
}
//# sourceMappingURL=configure_react_logger.js.map